import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from '@app/core';
import { TrackingService } from '@app/core/tracking.service';
import { Question, SolveQuestionResult } from '@app/models/question';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'question-dialog',
  templateUrl: 'question-dialog.component.html',
})
export class QuestionDialogComponent extends BaseComponent implements OnInit {
  public isInit: boolean = false;

  public questions!: Question[];
  public questionBaseUrl!: string;

  public isQuestionCorrect: boolean | undefined = undefined;

  constructor(
    public dialogRef: MatDialogRef<QuestionDialogComponent>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _fb: FormBuilder,
    private trackingService: TrackingService,
  ) {
    super();
    this.dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.isInit = true;

    if (this.data.questions) {
      this.questions = this.data.questions;
    }
    if (this.data.questionBaseUrl) {
      this.questionBaseUrl = this.data.questionBaseUrl;
    }
  }

  questionAnswered(answer: SolveQuestionResult) {
    this.isQuestionCorrect = answer.is_correct;
  }

  // Schließen-Button ("X"): Frage abbrechen – nur solange noch nicht beantwortet.
  abort(): void {
    if (this.isQuestionCorrect === undefined && this.questions?.length) {
      this.trackingService.trackQuestionAbort(
        String(this.questions[0].id),
        this.questionBaseUrl,
      );
    }
    this.close('aborted');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  close(data?: any): void {
    this.dialogRef.close(data);
  }
}
